import { TreatmentType, CodingAttributes, Score } from "@keita/lanepatrol-sdk";
import { getAttributeValue } from "../../coding/utils/attribute-value";
import {
  isScoreFiltersEmpty,
  CraAttributeFilter,
  CraAttributeFilterType,
  ScoreFilters,
  ScoreFilterType,
} from "../../map/models/MapFilters";
import { Treatment } from "../../cra/models/CraNode";
import { CraWay } from "../../cra/models/CraWay";
import { LifeCycleStage } from "../../cra/models/LifeCycleStage";

export function isNodeVisibleByAttributes(
  attributes: CodingAttributes,
  attributeFilters: CraAttributeFilter[],
) {
  if (!attributeFilters.length) return true;

  for (const filter of attributeFilters) {
    const attributeName = filter.attributeName;

    switch (filter.type) {
      case CraAttributeFilterType.Number: {
        const value = attributes[attributeName as keyof CodingAttributes] as
          | number
          | null;
        if (value !== null) {
          if (filter.min && filter.min > value) return false;
          if (filter.max && filter.max < value) return false;
        }
        break;
      }

      case CraAttributeFilterType.Select: {
        if (filter.value !== getAttributeValue(attributeName, attributes)) {
          return false;
        }

        break;
      }

      case CraAttributeFilterType.TextArea: {
        if (
          filter.value !==
          Boolean(attributes[attributeName as keyof CodingAttributes])
        ) {
          return false;
        }
        break;
      }
    }
  }
  return true;
}

export function isVisibleByScore(
  score: Score | null,
  scoreFilters: ScoreFilters,
) {
  if (isScoreFiltersEmpty(scoreFilters)) return true;
  if (!score) return false;

  for (const [filterType, filterValue] of Object.entries(scoreFilters)) {
    if (filterValue.type === ScoreFilterType.Limits) {
      const scoreValue = score[filterType as keyof Score].value;
      if (scoreValue < filterValue.limits.min) return false;
      if (scoreValue > filterValue.limits.max) return false;
    } else {
      const riskFactor = score[filterType as keyof Score].riskFactor;
      if (!filterValue.riskFactors.includes(riskFactor)) return false;
    }
  }

  return true;
}

export function isNodeVisibleByTreatment(
  nodeTreatments: Treatment[] | null,
  treatmentFilters: TreatmentType[],
) {
  if (!treatmentFilters.length) return true;
  if (!nodeTreatments) return false;
  for (const treatmentType of treatmentFilters) {
    if (!nodeTreatments.some((t) => t.type === treatmentType)) return false;
  }
  return true;
}

export function isCraWayVisibleThroughFilters(
  craWayId: string,
  craWayFilters: string[],
) {
  if (!craWayFilters.length) return true;
  return craWayFilters.includes(craWayId);
}

export function isLifeCycleStateVisibleThroughFilters(
  craWay: CraWay | null,
  lifeCycleStageFilters: LifeCycleStage[],
) {
  if (!lifeCycleStageFilters.length) return true;
  if (!craWay) return false;
  return lifeCycleStageFilters.includes(craWay.lifeCycleStage);
}
